import { Line } from "react-chartjs-2";
import { Chart, ChartArea, ChartOptions, registerables } from "chart.js";
import classes from "./ValueCard.module.scss";
import GraphUp from "../../../assets/GraphUp";
import classNames from "classnames";
import NoDataComponent from "../NoDataComponent";
import { Tooltip } from "antd";
Chart.register(...registerables);

type Data = {
  x: number;
  y: number;
};

type Gradient = {
  addColorStop: (position: number, color: string) => void;
};

type Color = {
  background: string;
  line: string;
};

export type ValueCardProps = {
  data?: Data[];
  title: string;
  value: any;
  remark?: string;
  color: Color;
  onClick?: () => void;
  hideInsight?: boolean;
  hideChart?: boolean;
  showImage?: boolean;
  image?: string;
  customStyle?: any;
  showLineGraph?: boolean;
};

const sampleChartData = [
  { x: 1, y: 25 },
  { x: 2, y: 55 },
  { x: 3, y: 15 },
  { x: 4, y: 95 },
  { x: 5, y: 65 },
];

export const ValueCard = ({
  data = [],
  title,
  value,
  remark = "",
  color,
  onClick = () => {},
  hideInsight = false,
  hideChart,
  showImage = false,
  image = "",
  customStyle = {},
  showLineGraph = true,
}: ValueCardProps) => {
  const getGradient = (ctx: CanvasRenderingContext2D, chartArea: ChartArea) => {
    const gradient: Gradient = ctx.createLinearGradient(
      0,
      chartArea.top,
      0,
      chartArea.bottom
    );
    gradient.addColorStop(0, "#00000020");
    gradient.addColorStop(1, "#00000000");
    return gradient;
  };

  const chartOptions: ChartOptions<"line"> = {
    maintainAspectRatio: false,
    datasets: {
      line: {
        fill: true,
        tension: 0.3,
        borderWidth: 2,
        borderColor: color.line,
        pointBorderWidth: 0,
        pointRadius: 5,
        pointBackgroundColor: "transparent",
      },
    },
    hover: { mode: undefined },
    backgroundColor: function (context) {
      const chart = context.chart;
      const { ctx, chartArea } = chart;
      if (!chartArea) {
        return;
      }
      return getGradient(ctx, chartArea);
    },
    scales: {
      x: {
        display: false,
      },
      y: {
        display: false,
        beginAtZero: true,
      },
    },
    plugins: {
      tooltip: {
        enabled: false,
      },
      legend: {
        display: false,
      },
    },
  };

  const dataset =
    data.length > 0
      ? {
          labels: data?.map((item) => item.x),
          datasets: [
            {
              data: data,
            },
          ],
        }
      : {
          labels: sampleChartData?.map((item) => item.y),
          datasets: [
            {
              data: sampleChartData,
            },
          ],
        };

  return (
    <div
      className={classNames(classes.card)}
      style={{
        background: color.background,
      }}
      onClick={onClick}
    >
      <div className="w-full flex flex-col md:gap-3 gap-0 md:p-3.5 p-2 pb-0 pt-2 overflow-auto ">
        <div className={`${classes.card__header} md:text-[22px] text-[12px]`}>
          {title}
        </div>

        <div
          className={`${classNames(classes.card__value)}  md:text-[32px] text-[22px]`}
        >
          <div
            className={classes.card__value_amount}
            style={customStyle?.remark}
          >
            {/* <Tooltip title={value}>*/}
            {value}
            {/*</Tooltip>*/}
          </div>
          {remark && (
            <div
              className={`${classes.card__value_text} md:text-[12px] text-[7px]`}
            >
              {remark}
            </div>
          )}
        </div>
      </div>
      {showLineGraph ? (
        <div className={classes.card__lineChart}>
          <Line data={dataset} options={chartOptions} />
        </div>
      ) : null}
      {!hideInsight ? (
        <div
          className={`${classes.card__insight} text-salara md:text-[12px] text-[6px]`}
        >
          <GraphUp stroke={"white"} width="9.23" height="5.54" />
          <p>view more insight</p>
        </div>
      ) : null}
    </div>
  );
};
